<div class="dialog-container">
  <div class="dialog-header">
    <h2>जाहिरात व्यवसाय अहवाल - प्रतिनिधी आधारित</h2>
  </div>

  <div class="dialog-content">

    <!-- Loading Indicator -->
    <div *ngIf="isLoading" class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>डेटा लोड होत आहे...</p>
    </div>

    <!-- No Data Message -->
    <div *ngIf="!isLoading && businessReportData.length === 0" class="no-data">
      <mat-icon>info</mat-icon>
      <p>या कालावधीसाठी कोणताही डेटा उपलब्ध नाही.</p>
    </div>

    <!-- Report Table -->
    <div *ngIf="!isLoading && businessReportData.length > 0"
         class="report-wrapper print-section"
         id="business-report-table">

      <table class="ledger-table">
        <thead>

          <!-- ── Row 1: Top-level headers ── -->
          <tr>
            <th rowspan="3">अ.क्र.</th>
            <th rowspan="3" class="rep-name-header">प्रतिनिधीचे नाव</th>

            <th colspan="3" class="title-bg">प्रतिनिधीचे नाव</th>

            <th [attr.colspan]="getTotalColspan()" class="main-header-bg" style="font-size: 14px;">
              जाहिरात विभाग नियोजन - वर्ष {{ getFinancialYearDisplay() }}
            </th>

            <!-- ✅ These 3 columns span all 3 header rows -->
            <th rowspan="3" class="total-header">एकूण</th>
            <th rowspan="3" class="total-header" style="min-width:120px;">
              जाहिरात करार वापरणे बाकी
            </th>
            <th rowspan="3" class="total-header" style="min-width:120px; background-color:#2e7d32 !important; color:#fff !important;">
              एकूण व्यवसाय
            </th>
          </tr>

          <!-- ── Row 2: उद्दिष्ट / पूर्तता / बाकी + Month names ── -->
          <tr>
            <!-- उद्दिष्ट -->
            <th rowspan="2" class="input-header" style="min-width:100px;">
              उद्दिष्ट
              <div style="font-size:10px; font-weight:normal; color:#666;">(आपोआप जतन होते)</div>
            </th>

            <!-- उद्दिष्ट पूर्तता -->
            <th rowspan="2" class="target-header" style="min-width:130px;">
              उद्दिष्ट पूर्तता<br/>
              <span style="font-size:10px; font-weight:normal;">(रक्कम / %)</span>
            </th>

            <!-- उद्दिष्ट बाकी -->
            <th rowspan="2" class="new-col-header" style="min-width:100px;">उद्दिष्ट बाकी</th>

            <!-- Month headers -->
            <ng-container *ngFor="let monthData of headerStructure; let mi = index">
              <th [attr.colspan]="monthData.colspan"
                  class="month-header"
                  [style.background-color]="getMonthColor(mi)"
                  style="border-left: 2.5px solid #000 !important;
                         border-right: 2.5px solid #000 !important;">
                {{ monthMarathi[monthData.month] }} {{ monthData.year_suffix }}
              </th>
            </ng-container>
          </tr>

          <!-- ── Row 3: Individual issue names ── -->
          <tr>
            <ng-container *ngFor="let monthData of headerStructure; let mi = index">
              <th *ngFor="let issue of monthData.issues; let first = first; let last = last"
                  class="vertical-text"
                  [style.background-color]="getMonthColor(mi)"
                  [style.border-left]="first ? '2.5px solid #000' : '1px solid #ccc'"
                  [style.border-right]="last  ? '2.5px solid #000' : '1px solid #ccc'">
                {{ issue }}
              </th>
            </ng-container>
          </tr>

        </thead>

        <tbody>
          <ng-container *ngFor="let catGroup of categoryGroups; let catIndex = index">

            <tr *ngFor="let repData of catGroup.representatives; let i = index">

              <!-- अ.क्र. -->
              <td class="serial-cell">{{ getGlobalRepIndex(catIndex, i) }}</td>

              <!-- प्रतिनिधीचे नाव -->
              <td class="rep-name-cell">{{ repData.off_rep_name }}</td>

              <!-- ✅ उद्दिष्ट — editable, auto-saves on change (no button needed) -->
              <td class="input-cell" style="min-width:100px;">
                <input
                  type="number"
                  [(ngModel)]="repData.input_value"
                  (change)="onInputValueChange(repData, $event)"
                  class="input-field"
                  style="width:100%;"
                  min="0"
                  step="0.01"
                  placeholder="0" />
              </td>

              <!-- उद्दिष्ट पूर्तता -->
              <td style="text-align:center; min-width:130px; padding:4px; vertical-align:middle;">
                <div style="font-weight:bold; font-size:13px; color:#1a1a1a;">
                  {{ repData.total > 0 ? formatCurrency(repData.total) : '0' }}
                </div>
                <div *ngIf="(repData.input_value || 0) > 0"
                     style="font-size:12px; color:#E65100; font-weight:bold; margin-top:3px;">
                  {{ getPct(repData.total, repData.input_value) }}%
                </div>
                <div *ngIf="(repData.input_value || 0) === 0"
                     style="font-size:11px; color:#aaa;">—</div>
              </td>

              <!-- उद्दिष्ट बाकी -->
              <td class="new-col-cell"
                  style="text-align:center; border-right:1px solid #0e0d0d;
                         min-width:110px; padding:4px; vertical-align:middle;"
                  [style.color]="((repData.input_value||0) - repData.total) < 0
                                  ? '#d32f2f' : '#1b5e20'">
                <ng-container *ngIf="(repData.input_value || 0) > 0">
                  <div style="font-weight:bold; font-size:13px;">
                    {{ formatCurrency((repData.input_value || 0) - repData.total) }}
                  </div>
                  <div style="font-size:12px; font-weight:bold; margin-top:3px;">
                    {{ getPct((repData.input_value || 0) - repData.total, repData.input_value) }}%
                  </div>
                </ng-container>
                <ng-container *ngIf="(repData.input_value || 0) === 0">
                  <span style="color:#aaa;">—</span>
                </ng-container>
              </td>

              <!-- Issue amount cells -->
              <ng-container *ngFor="let monthData of headerStructure; let mi = index">
                <td *ngFor="let issue of monthData.issues; let first = first; let last = last"
                    class="amount-cell"
                    style="text-align:end;"
                    [style.background-color]="getMonthColor(mi)"
                    [style.border-left]="first ? '2.5px solid #000' : '1px solid #ccc'"
                    [style.border-right]="last  ? '2.5px solid #000' : '1px solid #ccc'">
                  {{ formatCurrency(
                      getRepMonthIssueValue(repData, monthData.month, monthData.year_suffix, issue)
                  ) }}
                </td>
              </ng-container>

              <!-- एकूण (row total) -->
              <td class="total-cell" style="text-align:end;">
                {{ formatCurrency(repData.total) }}
              </td>

              <!-- ✅ जाहिरात करार वापरणे बाकी — read-only, from contract report -->
              <td class="total-cell"
                  style="text-align:end; min-width:120px; background-color:#fff8e1;">
                {{ formatCurrency(repData.jaahirat_karar_baki || 0) }}
              </td>

              <!-- ✅ एकूण व्यवसाय = एकूण + जाहिरात करार वापरणे बाकी -->
              <td class="total-cell"
                  style="text-align:end; min-width:120px;
                         background-color:#e8f5e9; font-weight:bold;">
                {{ formatCurrency((repData.total || 0) + (repData.jaahirat_karar_baki || 0)) }}
              </td>

            </tr>

          </ng-container>
        </tbody>

        <!-- ═══ FOOTER ═══ -->
        <tfoot>

          <!-- Grand Total Row -->
          <tr class="total-row">
            <td colspan="2">एकूण</td>

            <!-- उद्दिष्ट total -->
            <td class="input-total" style="text-align:end;">
              {{ formatCurrency(calculateInputValuesTotal()) }}
            </td>

            <!-- उद्दिष्ट पूर्तता footer -->
            <td style="text-align:center; padding:4px; vertical-align:middle;">
              <div style="font-weight:bold; font-size:13px;">
                {{ formatCurrency(calculateGrandTotal()) }}
              </div>
              <div *ngIf="calculateInputValuesTotal() > 0"
                   style="font-size:12px; color:#E65100; font-weight:bold; margin-top:3px;">
                {{ getPct(calculateGrandTotal(), calculateInputValuesTotal()) }}%
              </div>
              <div *ngIf="calculateInputValuesTotal() === 0"
                   style="font-size:11px; color:#aaa;">—</div>
            </td>

            <!-- उद्दिष्ट बाकी grand total -->
            <td class="new-col-cell"
                style="text-align:center; padding:4px; vertical-align:middle;"
                [style.color]="(calculateInputValuesTotal() - calculateGrandTotal()) < 0
                                ? '#d32f2f' : '#1b5e20'">
              <ng-container *ngIf="calculateInputValuesTotal() > 0">
                <div style="font-weight:bold; font-size:13px;">
                  {{ formatCurrency(calculateInputValuesTotal() - calculateGrandTotal()) }}
                </div>
                <div style="font-size:12px; font-weight:bold; margin-top:3px;">
                  {{ getPct(calculateInputValuesTotal() - calculateGrandTotal(),
                            calculateInputValuesTotal()) }}%
                </div>
              </ng-container>
              <ng-container *ngIf="calculateInputValuesTotal() === 0">
                <span style="color:#aaa;">—</span>
              </ng-container>
            </td>

            <!-- Issue column totals -->
            <ng-container *ngFor="let monthData of headerStructure; let mi = index">
              <td *ngFor="let issue of monthData.issues; let first = first; let last = last"
                  class="total-cell"
                  style="text-align:end;"
                  [style.background-color]="getMonthColor(mi)"
                  [style.border-left]="first ? '2.5px solid #000' : '1px solid #ccc'"
                  [style.border-right]="last  ? '2.5px solid #000' : '1px solid #ccc'">
                {{ formatCurrency(
                    calculateIssueTotal(monthData.month, monthData.year_suffix, issue)
                ) }}
              </td>
            </ng-container>

            <!-- एकूण grand total -->
            <td class="grand-total" style="text-align:end;">
              {{ formatCurrency(calculateGrandTotal()) }}
            </td>

            <!-- ✅ जाहिरात करार वापरणे बाकी grand total -->
            <td class="grand-total"
                style="text-align:end; background-color:#fff8e1 !important;">
              {{ formatCurrency(calculateJaahiratKararBakiTotal()) }}
            </td>

            <!-- ✅ एकूण व्यवसाय grand total -->
            <td class="grand-total"
                style="text-align:end; background-color:#c8e6c9 !important;">
              {{ formatCurrency(calculateEkunVyavsay()) }}
            </td>
          </tr>

          <!-- Month-wise Total Row -->
          <tr class="month-total-bottom-row">
            <td colspan="5" class="footer-total-label"
                style="text-align:center; background:#E3F2FD;
                       font-weight:bold; border: 2px solid #0a0a0a;">
              महिनानिहाय एकूण
            </td>

            <ng-container *ngFor="let monthData of headerStructure; let mi = index">
              <td [attr.colspan]="monthData.colspan"
                  class="month-grand-total"
                  [style.background-color]="getMonthColor(mi)"
                  style="text-align:center; font-weight:bold; font-size:12px;
                         border-left:  2.5px solid #000 !important;
                         border-right: 2.5px solid #000 !important;">
                {{ formatCurrency(
                    calculateMonthGrandTotal(monthData.month, monthData.year_suffix)
                ) }}
              </td>
            </ng-container>

            <td class="grand-total" style="text-align:end;">
              {{ formatCurrency(calculateGrandTotal()) }}
            </td>

            <!-- ✅ Empty cells for the 2 extra columns in month-total row -->
            <td></td>
            <td></td>
          </tr>

        </tfoot>
      </table>
    </div>
  </div>

  <!-- Dialog Actions -->
  <div class="dialog-actions">
    <button mat-raised-button color="primary" (click)="printPageA3Portrait()">
      <mat-icon>print</mat-icon>
      Print
    </button>
    <button mat-raised-button color="primary"
            (click)="exportToExcel()"
            [disabled]="isLoading || businessReportData.length === 0">
      <mat-icon>download</mat-icon>
      Excel निर्यात करा
    </button>
    <button mat-raised-button (click)="closeDialog()">बंद करा</button>
  </div>
</div>